(() => {
  const stateKey = 'jianan-floating-enquiry-state';
  const initialize = () => {
    document.querySelectorAll('[data-jfe-widget]').forEach((widget) => {
      if (widget.dataset.jfeReady) return;
      widget.dataset.jfeReady = 'true';
      const submittedHere = window.location.hash === '#JiananFloatingContactForm';
      const success = widget.querySelector('[data-jfe-success]');
      const errors = widget.querySelector('[data-jfe-errors]');
      let minimized = false;
      try {
        minimized = sessionStorage.getItem(stateKey) === 'collapsed';
      } catch {}
      widget.open = submittedHere || !minimized || Boolean(errors);
      if (success) success.hidden = !submittedHere;
      widget.addEventListener('toggle', () => {
        try {
          sessionStorage.setItem(stateKey, widget.open ? 'expanded' : 'collapsed');
        } catch {}
      });
      widget.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && widget.open) {
          widget.open = false;
          widget.querySelector('summary').focus();
        }
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
